import { render } from "./AppFrames.vue?vue&type=template&id=5131face"
import script from "./AppFrames.vue?vue&type=script&lang=js"
export * from "./AppFrames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__